import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AutocompleteLoadingModeType, ChipList, IAutocompleteSchema } from 'maps-angular-components';

import { HttpClient } from "@angular/common/http";
import { FormGroup } from '@angular/forms';
import { ParametroFuncao } from 'src/app/funcao/models/parametro-funcao';
import { Autocomplete } from '../autocomplete';
import { AutocompleteService } from '../autocomplete.service';

@Component({
  selector: 'app-autocomplete-multiselect',
  templateUrl: './autocomplete-multiselect.component.html',
  styleUrls: ['./autocomplete-multiselect.component.scss']
})
export class AutocompleteMultiselectComponent implements OnInit {

  @Input() parametroFuncaoSchema: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    variavel: ""
  };
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() value: ChipList<Autocomplete>;
  @Input() readonly = false;

  public schema: IAutocompleteSchema<Autocomplete>

  constructor(
    private readonly httpClient: HttpClient,
    private readonly changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    if (this.value) {
      this.value.items = this.value?.items?.map(i => new Autocomplete(i));
    }
    this.formGroup.get(this.parametroFuncaoSchema.variavel).disable({emitEvent:true})
    this.parametroFuncaoSchema.dependencias.forEach(it => {
      this.formGroup.get(it)?.statusChanges.subscribe(c => {
        let enable = this.parametroFuncaoSchema.dependencias
          .filter(p => this.formGroup.get(p).value == null).length > 0
        if(enable){
          this.formGroup.get(this.parametroFuncaoSchema.variavel).enable({emitEvent:true})
        }else{
          this.formGroup.get(this.parametroFuncaoSchema.variavel).disable({emitEvent:true})
        }
        this.changeDetector.detectChanges();
      })
    })
    this.createSchema();
    this.changeDetector.detectChanges();
  }

  private createSchema() {
    this.schema = {
      service: new AutocompleteService(this.httpClient, this.parametroFuncaoSchema?.endpointOpcoes, this.formGroup,
        this.parametroFuncaoSchema.dependencias),
      label: this.parametroFuncaoSchema ? this.parametroFuncaoSchema.label : "",
      hint: this.parametroFuncaoSchema?.autocompleteHint,
      placeholder: this.parametroFuncaoSchema ? this.parametroFuncaoSchema.label : "",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      required: this.parametroFuncaoSchema ? this.parametroFuncaoSchema.obrigatorio : false,
      autoload: false,
      readonly: this.readonly,
      endpoint: this.parametroFuncaoSchema?.endpointOpcoes,
      formGroup: this.formGroup,
      formControlName: this.parametroFuncaoSchema ? this.parametroFuncaoSchema.variavel : "",
      formDependentFilters: this.parametroFuncaoSchema.dependencias,
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
      parsePaginatedResponse(res: string[]) {
        return {
          total: res.length,
          data: res.map(item => new Autocomplete({
            id: item,
            nome: item
          }))
        };
      }
    };
  }
}
